import React, { useState, useEffect } from "react";
import { MetricsCard } from '../components/MetricsCard';
import { HealthChart } from '../components/HealthChart';
import { TeamCard } from '../components/TeamCard';
import { Briefcase, Building, Users, AlertTriangle, ChevronDown, ChevronRight, HelpCircle, X, UserRoundCheck, Hourglass } from 'lucide-react';
import { useNavigate, Link } from "react-router-dom";

export const Insights = ({ caller, clientInfo }) => {

    // const [expandedClients, setExpandedClients] = useState(() => new Set(JSON.parse(localStorage.getItem('expandedClients'))) || new Set());
    // const [expandedBUs, setExpandedBUs] = useState(() => new Set(JSON.parse(localStorage.getItem('expandedBUs'))) || new Set());
    // const [activeTab, setActiveTab] = useState(() => localStorage.getItem('activeTab') || 'risk');
    // const [showHelpModal, setShowHelpModal] = useState(false);
    const navigate = useNavigate();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    // const oneMonthAhead = new Date();
    // oneMonthAhead.setMonth(oneMonthAhead.getMonth() + 1);

    // useEffect(() => {
    //     if (!teamsReady) return;
    //     const teamToScrollTo = sessionStorage.getItem('scroll-to-team');
    //     if (teamToScrollTo) {
    //         const el = document.getElementById(`team-${teamToScrollTo}`);
    //         if (el) {
    //             el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //         }
    //         sessionStorage.removeItem('scroll-to-team');
    //     }
    // }, [teamsReady]);

    // const handleTeamClick = (clientName, buName, teamName) => {
    //     sessionStorage.setItem('scroll-to-team', teamName);
    //     navigate(
    //         `/customers/${clientName}/${buName}/${encodeURIComponent(teamName)}`
    //     );
    // };

    let customerName = ''
    if (caller === 'team') {
        customerName = clientInfo?.[0]?.clientName || '';
    }

    const allTeams = clientInfo.flatMap((client) =>
        client.businessUnits.flatMap((bu) =>
            bu.teams.map((team) => ({
                ...team,
                clientName: client.clientName,
                buName: bu.buName,
            }))
        )
    );

    function calcNewTeams(allTeams) {
        return allTeams.filter((team) => new Date(team.teamStartDate) >= threeMonthsAgo)
            .sort(
                (a, b) => new Date(b.teamStartDate) - new Date(a.teamStartDate)
            );
    }

    // function calcClosingTeams(allTeams) {
    //     return allTeams.filter((team) => new Date(team.teamEndDate) < oneMonthAhead)
    //         .sort(
    //             (a, b) => new Date(b.teamEndDate) - new Date(a.teamEndDate)
    //         );
    // }

    // const getFilteredTeams = () => {
    //     switch (activeTab) {
    //         case "risk":
    //             return allTeams
    //                 .filter(
    //                     (team) =>
    //                         (team.performanceIndex.overallHealth === "At Risk" ||
    //                         team.performanceIndex.overallHealth === "Critical") &&
    //                         new Date(team.teamStartDate) < threeMonthsAgo
    //                 )
    //                 .sort((a, b) =>
    //                     b.performanceIndex.overallHealth.localeCompare(
    //                         a.performanceIndex.overallHealth
    //                     )
    //                 );
    //         case "new":
    //             return calcNewTeams(allTeams)
    //         case "investment":
    //             return allTeams.filter(team => team.investment && team.investment.count > 0)
    //                             .sort((a, b) => {
    //                                 const healthPriority = {
    //                                     "Critical": 3,
    //                                     "At Risk": 2,
    //                                     "Healthy": 1
    //                                 };
    //                                 return healthPriority[b.performanceIndex.overallHealth] - 
    //                                         healthPriority[a.performanceIndex.overallHealth];
    //                             })
    //         case "closing":
    //             return calcClosingTeams(allTeams)
    //         default:
    //             return [];
    //     }
    // };

    // const toggleClient = (clientName) => {
    //     const newExpanded = new Set(expandedClients);
    //     if (newExpanded.has(clientName)) {
    //         newExpanded.delete(clientName);
    //     } else {
    //         newExpanded.add(clientName);
    //     }
    //     setExpandedClients(newExpanded);
    //     localStorage.setItem('expandedClients', JSON.stringify(Array.from(newExpanded)));
    // };

    // const toggleBU = (buName) => {
    //     const newExpanded = new Set(expandedBUs);
    //     if (newExpanded.has(buName)) {
    //         newExpanded.delete(buName);
    //     } else {
    //         newExpanded.add(buName);
    //     }
    //     setExpandedBUs(newExpanded);
    //     localStorage.setItem('expandedBUs', JSON.stringify(Array.from(newExpanded)));
    // };

    // const renderHierarchicalView = () => (
    //     <div className="space-y-4">
    //         {clientInfo.map((client) => (
    //             <div
    //                 key={client.clientName}
    //                 className="bg-white rounded-lg shadow-sm border border-gray-200"
    //             >
    //                 <button
    //                     className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-gray-50"
    //                     onClick={() => toggleClient(client.clientName)}
    //                 >
    //                     <div className="flex items-center">
    //                         {expandedClients.has(client.clientName) ? (
    //                             <ChevronDown className="w-5 h-5 text-gray-400 mr-2" />
    //                         ) : (
    //                             <ChevronRight className="w-5 h-5 text-gray-400 mr-2" />
    //                         )}
    //                         <img
    //                             src={`/images/${client.clientName}.png`}
    //                             alt={`${client.clientName} logo`}
    //                             className="max-w-[8rem] h-12 rounded-lg object-contain mr-3"
    //                         />
    //                         {/* <span className="font-medium text-gray-900">{client.clientName}</span> */}
    //                     </div>
    //                     <span className="text-sm text-gray-500">
    //                         {client.businessUnits.reduce(
    //                             (acc, bu) => acc + bu.teams.length,
    //                             0
    //                         )}{" "}
    //                         Teams
    //                     </span>
    //                 </button>

    //                 {expandedClients.has(client.clientName) && (
    //                     <div className="pl-8 pr-4 pb-4">
    //                         {client.businessUnits.map((bu) => (
    //                             <div key={bu.buName} className="mt-2">
    //                                 <button
    //                                     className="w-full px-4 py-2 flex items-center justify-between text-left hover:bg-gray-50 rounded"
    //                                     onClick={() => toggleBU(bu.buName)}
    //                                 >
    //                                     <div className="flex items-center">
    //                                         {expandedBUs.has(bu.buName) ? (
    //                                             <ChevronDown className="w-4 h-4 text-gray-400 mr-2" />
    //                                         ) : (
    //                                             <ChevronRight className="w-4 h-4 text-gray-400 mr-2" />
    //                                         )}
    //                                         <span className="text-sm font-medium text-gray-700">
    //                                             {bu.buName}
    //                                         </span>
    //                                     </div>
    //                                     <div className="flex items-center space-x-4">
    //                                         {bu.teamsAtRisk > 0 && (
    //                                             <span className="text-sm text-red-600">
    //                                                 At Risk: {bu.teamsAtRisk}
    //                                             </span>
    //                                         )}
    //                                         <span className="text-sm text-gray-500">
    //                                             Total: {bu.teams.length}
    //                                         </span>
    //                                     </div>
    //                                 </button>

    //                                 {expandedBUs.has(bu.buName) && (
    //                                     <div className="pl-8 pr-4 mt-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
    //                                         {bu.teams.map((team) => (
    //                                             <TeamCard
    //                                                 key={team.teamName}
    //                                                 team={{
    //                                                     ...team,
    //                                                     clientName: client.clientName,
    //                                                     buName: bu.buName,
    //                                                 }}
    //                                                 onClick={handleTeamClick}
    //                                             />
    //                                         ))}
    //                                     </div>
    //                                 )}
    //                             </div>
    //                         ))}
    //                     </div>
    //                 )}
    //             </div>
    //         ))}
    //     </div>
    // );
    
    // useEffect(() => {
    //     if (activeTab == 'all' || getFilteredTeams().length > 0) {
    //         requestAnimationFrame(() => {
    //             setTimeout(() => {
    //                 setTeamsReady(true);
    //             }, 100);
    //         });
    //     }
    // }, [getFilteredTeams, renderHierarchicalView]);

    const calcTeamMetrics = () => {
        const metrics = {}
        const now = new Date();
        
        // Helper function to check if a team is closed (has endDate in the past)
        const isTeamClosed = (team) => {
            if (!team.teamEndDate) return false;
            const endDate = new Date(team.teamEndDate);
            return !isNaN(endDate.getTime()) && endDate < now;
        };
        
        // Helper function to check if a team is at risk (matching TeamsOverview filter logic)
        const isTeamAtRisk = (team) => {
            if (isTeamClosed(team)) return false;

            const teamHealth = team.performanceIndex?.teamHealth || team.teamHealth || '';
            const relationshipHealth = team.performanceIndex?.relationshipHealth || team.relationshipHealth || '';
            const deliveryHealth = team.performanceIndex?.deliveryHealth || team.deliveryHealth || '';

            const metrics = [teamHealth, relationshipHealth, deliveryHealth];
            const allStartStrong = metrics.every(status => status === 'Start Strong');
            const hasRiskyMetric = metrics.some(status => status === 'At Risk' || status === 'Critical');

            return hasRiskyMetric && !allStartStrong;
        };
        
        if (caller == 'client') {
            metrics.totalClients = clientInfo.length;
            // Filter out closed teams from total count
            metrics.totalTeams = clientInfo.map(client => 
                client.businessUnits.reduce((acc, bu) => 
                    acc + bu.teams.filter(team => !isTeamClosed(team)).length, 0)
            ).reduce((sum, len) => sum + len, 0);
            metrics.teamsAtRisk = clientInfo.map(client => 
                client.businessUnits.reduce((acc, bu) => 
                    acc + bu.teams.filter(team => isTeamAtRisk(team)).length, 0)
            ).reduce((sum, len) => sum + len, 0);
        } else {
            metrics.totalClients = clientInfo.map(client => client.businessUnits.length);
            // Filter out closed teams from total count
            metrics.totalTeams = clientInfo.map(client => 
                client.businessUnits.reduce((acc, bu) => 
                    acc + bu.teams.filter(team => !isTeamClosed(team)).length, 0)
            );
            metrics.teamsAtRisk = clientInfo.map(client => 
                client.businessUnits.reduce((acc, bu) => 
                    acc + bu.teams.filter(team => isTeamAtRisk(team)).length, 0)
            );
        }
        metrics.newTeams = calcNewTeams(allTeams).length;
        return metrics;
    }

    // const HelpModal = () => (
    //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    //         <div className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4 max-h-[85vh] overflow-y-auto">
    //             <div className="flex justify-between items-center mb-4">
    //                 <h2 className="text-xl font-bold">How to Update Team Information</h2>
    //                 <button
    //                     onClick={() => setShowHelpModal(false)}
    //                     className="text-gray-500 hover:text-gray-700"
    //                 >
    //                     <X className="w-6 h-6" />
    //                 </button>
    //             </div>
    //             <div className="prose p-4">
    //                 <h3 className="text-lg font-semibold mb-2">To update Engagement Health details, follow these steps:</h3>
    //                 <ol className="list-decimal mb-4 pl-5 space-y-2">
    //                     <li>Go to the <a href="https://triconindia-my.sharepoint.com/:x:/r/personal/adi_chikara_triconinfotech_com/Documents/Engagement%20Health%20Index.xlsx?d=w7cdd34c29fbf4dd7b600c9bbc8d49568&csf=1&web=1&e=WWHyMF" target="_blank" class="text-blue-500 hover:underline">Engagement Sheet</a> and navigate to <strong>Health Index</strong> sheet.</li>
    //                     <li>Create a new row for new team.</li>
    //                     <li>Update the following fields:
    //                         <ul className="list-disc pl-5 mt-2">
    //                             <li>Customer</li>
    //                             <li>Team</li>
    //                             <li>Lead</li>
    //                             <li>Start Date</li>
    //                             <li>Last Updated Date</li>
    //                             <li>Delivery, Team, and Relationship Health</li>
    //                             <li>Growth of the Team</li>
    //                             <li>Key Notes</li>
    //                             <li>Customer Business Impact</li>
    //                         </ul>
    //                     </li>
    //                 </ol>
    //                 <h3 className="text-lg font-semibold mb-2">To update Team related details, follow these steps:</h3>
    //                 <ol className="list-decimal pl-5 space-y-2">
    //                     <li>Navigate to the <a href="https://triconindia-my.sharepoint.com/:x:/g/personal/mohak_khattwani_triconinfotech_com/EcgXns3bD2NDgVgPqcctAPcBRh0NfWeldh9ZzbEL122tkw" target="_blank" class="text-blue-500 hover:underline">Mission Control</a> Sheet.</li>
    //                     <li>Update the following fields:
    //                         <ul className="list-disc pl-5 mt-2">
    //                             <li>Customer</li>
    //                             <li>Business Unit</li>
    //                             <li>Team</li>
    //                             <li>Team Members</li>
    //                             <li>Previous Outcomes</li>
    //                             <li>Next Point of Value</li>
    //                             <li>Cycle Time</li>
    //                             <li>Product Lifecycle</li>
    //                             <li>Business Practices</li>
    //                         </ul>
    //                     </li>
    //                 </ol>


    //                 <div className="mt-4 p-4 bg-blue-50 rounded-lg">
    //                     <p className="text-blue-800 text-sm">
    //                         <strong>Important Notes:</strong> <br />
    //                         Customer and Team names must match across the sheets.<br />
    //                         The data updated in these sheets will take time to reflect in Mission Control. Updates are processed every <strong>Wednesday and Thursday.</strong><br /><br />
    //                         For any further queries, please reach out to the <strong>Engagement Leadership Group</strong> on Microsoft Teams.
    //                     </p>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // );

    // document.addEventListener('keydown', function (event) {
    //     if (event.key === 'Escape') {
    //         setShowHelpModal(false)
    //     }
    // });

    // const getEmptyMessage = () => {
    //     switch (activeTab) {
    //       case 'risk':
    //         return 'No at-risk teams to display.';
    //       case 'new':
    //         return 'No new teams to display.';
    //       case 'investment':
    //         return 'No investment teams to display.';
    //       default:
    //         return 'No teams to display.';
    //     }
    //   };

    return (
        <div className="min-h-screen pt-8">
            <div className="max-w-7xl mx-auto px-4 py-8">
                <div className="flex items-center justify-between mb-8">
                    <div>
                        <h1 className="text-2xl sm:text-3xl font-bold text-[#800000]">{caller === 'client' ? 'Team Dashboard' : `${customerName} Dashboard`}</h1>
                        {/* <span className="text-[10px] sm:text-xs text-gray-500 font-semibold">
                            Last updated: {lastModified}
                        </span> */}
                    </div>  
                    <div className="flex items-center space-x-2">
                        <Link
                        to="/touchpoints"
                        className="flex items-center px-4 py-2 text-[#800000] border border-[#800000] sm:text-base text-xs rounded-3xl hover:bg-[#80000010] transition-colors"
                        >
                        <UserRoundCheck className="w-5 h-5 mr-2" />
                        Customer Touchpoints
                        </Link>
                        {/* <span className="text-sm text-gray-500 font-semibold">
                            Last updated: {lastModified}
                        </span> */}
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row">
                    <MetricsCard
                        caller={caller}
                        metrics={calcTeamMetrics()}
                        onNavigateToTeams={() => navigate(caller === 'client' ? '/teams' : `/teams?customer=${customerName}`)}
                        onNavigateToNewTeams={() => navigate(caller === 'client' ? '/teams?filter=new' : `/teams?customer=${customerName}&filter=new`)}
                        onNavigateToAtRisk={() => navigate(caller === 'client' ? '/teams?filter=atRisk' : `/teams?customer=${customerName}&filter=atRisk`)}
                        // switchActiveTab={(tab) => {setActiveTab(tab); localStorage.setItem('activeTab', tab)}}
                    />

                    <HealthChart caller={caller} clients={clientInfo} />
                </div>

                {/* <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                    <div className="border-b border-gray-200">
                        <nav className="flex -mb-px overflow-x-auto scrollbar-hide">
                            <button
                                className={`px-6 py-4 text-sm font-medium flex items-center space-x-2 ${activeTab === "risk"
                                    ? "border-b-2 border-red-500 text-red-600"
                                    : "text-gray-500 hover:text-gray-700"
                                    }`}
                                onClick={() => {setActiveTab("risk"); localStorage.setItem('activeTab', "risk")}}
                            >
                                <AlertTriangle className="w-5 h-5" />
                                <span>At Risk Teams</span>
                            </button>
                            <button
                                className={`px-6 py-4 text-sm font-medium flex items-center space-x-2 ${activeTab === "new"
                                    ? "border-b-2 border-blue-500 text-blue-600"
                                    : "text-gray-500 hover:text-gray-700"
                                    }`}
                                onClick={() => {setActiveTab("new"); localStorage.setItem('activeTab', "new")}}
                            >
                                <Users className="w-5 h-5" />
                                <span>New Teams</span>
                            </button>
                            <button
                                className={`px-6 py-4 text-sm font-medium flex items-center space-x-2 ${activeTab === "investment"
                                    ? "border-b-2 border-purple-500 text-purple-600"
                                    : "text-gray-500 hover:text-gray-700"
                                    }`}
                                onClick={() => {setActiveTab("investment"); localStorage.setItem('activeTab', "investment")}}
                            >
                                <Briefcase className="w-5 h-5" />
                                <span>Investments Overview</span>
                            </button>
                            <button
                                className={`px-6 py-4 text-sm font-medium flex items-center space-x-2 ${activeTab === "closing"
                                    ? "border-b-2 border-orange-500 text-orange-600"
                                    : "text-gray-500 hover:text-gray-700"
                                    }`}
                                onClick={() => {setActiveTab("closing"); localStorage.setItem('activeTab', "closing")}}
                            >
                                <Hourglass className="w-5 h-5" />
                                <span>Closing Soon</span>
                            </button>
                            <button
                                className={`px-6 py-4 text-sm font-medium flex items-center space-x-2 ${activeTab === "all"
                                    ? "border-b-2 border-gray-500 text-gray-600"
                                    : "text-gray-500 hover:text-gray-700"
                                    }`}
                                onClick={() => {setActiveTab("all"); localStorage.setItem('activeTab', "all")}}
                            >
                                <Building className="w-5 h-5" />
                                <span>All Teams</span>
                            </button>
                        </nav>
                    </div>

                    <div className="p-6">
                        {activeTab === "all" ? (
                            renderHierarchicalView()
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                { getFilteredTeams().length > 0 ? (getFilteredTeams().map((team) => (
                                    <TeamCard activeTab={activeTab}
                                        team={team}
                                        key={team.teamName}
                                        onClick={handleTeamClick}
                                    />
                                ))) : (
                                    <div className="col-span-full text-center text-gray-500">
                                      {getEmptyMessage()}
                                    </div>
                                  )
                                }
                            </div>
                        )}
                    </div>
                </div> */}
                {/* <button
                    onClick={() => setShowHelpModal(true)}
                    className="fixed bottom-5 right-5 p-3 bg-[#800000] text-white rounded-full hover:text-[#800000] hover:bg-white border border-[#800000]"
                >
                    <HelpCircle className="w-6 h-6" />
                </button> */}
            </div>
            {/* {showHelpModal && <HelpModal />} */}
        </div>
    );
};
